<ng-container *ngIf="group && field">

    <div class="" [formGroup]="group" (reset)="resetValue()" [hidden]="field.hidden || false">
        <div class="flex flex-col align-top my-2">

            <label for="{{field!.name}}" class="label col-sm-3 col-form-label">{{field.label}}</label>

            <!-- <input #inputEl [id]="field.name" [readonly]="field.readonly || false" [hidden]="field.hidden ||  false"
                [formControlName]="field.name" class="hidden" (change)="changeLabel()" (reset)="resetValue()"
                [placeholder]="field.placeholder || '...'" [type]="'text'"> -->

            <mat-select #inputEl *ngIf="this.options?.selectType == 'multiple'" [(ngModel)]="selectedIdArray"
                [multiple]="true" class="mat-input rounded-xl" style="display: none!important;"
                [formControlName]="field.name" [placeholder]="field.placeholder || 'Seleziona un valore'"
                (valueChange)="changeLabel()">
                @for (data of dataSource; track data) {
                <mat-option [value]="data.id">{{data.codice}}</mat-option>
                }
            </mat-select>

            <mat-select #inputEl *ngIf="this.options?.selectType == 'single'" [(ngModel)]="selectedId"
                [multiple]="false" class="mat-input rounded-xl" style="display: none!important;"
                [formControlName]="field.name" [placeholder]="field.placeholder || 'Seleziona un valore'"
                (valueChange)="changeLabel()">
                @for (data of dataSource; track data) {
                <mat-option [value]="data.id">{{data.codice}}</mat-option>
                }
            </mat-select>

            <div *ngIf="inputEl"
                class="e-input flex items-center py-1 text-text  {{!inputEl!.disabled && !field.readonly ? 'cursor-pointer' : 'cursor-not-allowed'}} {{!inputEl.disabled ? '' : 'item-selector-select-displayer'}} "
                style="min-height: 2.5rem;"
                (click)="!inputEl.disabled && !field.readonly ? dialogKit.open() : dialogKit.close()">
                <p style="font-size: 0.9rem!important;"
                    class="ml-2 {{selectedIdArray[0] == 0 || selectedIdArray[0] == null  || selectedIdArray.length == 0  ? 'opacity-40' : ''}}">
                    {{selected || field.placeholder}}</p>
                <!-- <p >{{options?.popupLabel}}</p> -->
            </div>

            <!-- KEEP SELECTION WHEN FILTER -->
        </div>


        <div *ngIf="field.message!=undefined">
            <p class="text-sm">{{field.message}}</p>
        </div>
        <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
        <div class="flex align-top flex-col"
            *ngIf="group.controls[field.name].dirty || group.controls[field.name].touched">
            <ng-container *ngFor="let validation of field.validations;let i= index;">
                <!--<span *ngIf="group!.controls[field!.name].hasError(validation.name)"
                style="color: red;">{{validation.message}}&nbsp;&nbsp;</span>-->

                <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
                    class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                        <path d="M12 8v4" />
                        <path d="M12 16h.01" />
                    </svg>

                    <p>{{validation.message}}</p>
                </div>
            </ng-container>

        </div>

        <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError('highlight')"
            class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                <path d="M12 8v4" />
                <path d="M12 16h.01" />
            </svg>

            <p>{{group.controls[field.name].getError('highlight')}}</p>
        </div>

    </div>
</ng-container>


<ng-container *ngIf="!group || !field">

    <div class="main-wrapper" (reset)="resetValue()" [hidden]="parsedOptions.hidden || false">

        <div class="flex flex-col align-top my-2">

            <input #inputEl id="custom-item-sel" [readonly]="parsedOptions.readonly || false" class="hidden"
                (change)="changeLabel()" (reset)="resetValue()" [placeholder]="placeholder" [type]="'text'">

            <div class="e-input flex items-center cursor-pointer text-text" style="height: 2.5em;"
                (click)="dialogKit.open()">
                <p style="font-size: 0.9rem!important;"
                    class="ml-2 {{selectedIdArray[0] == 0 || selectedIdArray[0] == null  || selectedIdArray.length == 0  ? 'opacity-40' : ''}}">
                    {{selected || placeholder}}</p>
                <!-- <p >{{options?.popupLabel}}</p> -->
            </div>
            <!-- KEEP SELECTION WHEN FILTER -->
        </div>

    </div>

</ng-container>


<app-custom-dialog #dialogKit id="dialogKit" closeOnEscape="true" [options]="dialogOptions"
    (beforeDialogOpen)="loadRequiredData($event)" (afterDialogClose)="dialogCloesed($event)" showCloseIcon="true">


    <div content class="flex flex-col gap-3 w-full h-full text-text">




        <h1 *ngIf="!parsedOptions.listOnly">{{options?.popupLabel || 'Seleziona un elemento'}}</h1>

        <div *ngIf="!parsedOptions.listOnly">
            <h5 *ngIf="selected != options?.popupLabel">Selezionato: {{selected}}</h5>
        </div>

        <div class="flex flex-row gap-3 justify-between">

            <div *ngIf="!parsedOptions?.offlineFilter" class="flex justify-start gap-3 items-center">
                <div *ngFor="let input of options?.filters" class="min-w-60">

                    <div *ngIf="input.type == 'Text'">
                        <input [id]="input.filterName" class="e-input" [placeholder]="input.filterName" [type]="'text'"
                            [(ngModel)]="input.value" (keydown)="filter$.next()">
                    </div>

                    <div *ngIf="input.type == 'Dropdown'">
                        <app-custom-drop-down-list [fieldName]="input.filterName" [placeholder]="input.filterName"
                            [api]="true" [url]="input.api"
                            (genericChange)="filterValueChange($event, input.filterName)"></app-custom-drop-down-list>
                    </div>

                </div>
            </div>

            <div *ngIf="parsedOptions.offlineFilter">
                <input class="e-input" placeholder="Cerca..." [type]="'text'" [(ngModel)]="offlineFilterValue"
                    (keydown)="offlineFilter()">
            </div>

            <div class="flex flex-row gap-4">
                <button *ngIf="options?.showSelectAll && options?.selectType == 'multiple' && !selectedAll"
                    type="button" class="dl-button p-4 rounded-2xl flex flex-row justify-center items-center"
                    (click)="selectAll()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
                        <path d="M12 20v.01" />
                        <path d="M16 20v.01" />
                        <path d="M8 20v.01" />
                        <path d="M4 20v.01" />
                        <path d="M4 16v.01" />
                        <path d="M4 12v.01" />
                        <path d="M4 8v.01" />
                        <path d="M4 4v.01" />
                        <path d="M8 4v.01" />
                        <path d="M12 4v.01" />
                        <path d="M16 4v.01" />
                        <path d="M20 4v.01" />
                        <path d="M20 8v.01" />
                        <path d="M20 12v.01" />
                        <path d="M20 16v.01" />
                        <path d="M20 20v.01" />
                    </svg>
                    Seleziona tutto
                </button>

                <button *ngIf=" options?.showSelectAll && selectedAll" type="button"
                    class="delete-button p-4 rounded-2xl flex flex-row justify-center items-center"
                    (click)="unselectAll()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 8h3a1 1 0 0 1 1 1v3" />
                        <path d="M16 16h-7a1 1 0 0 1 -1 -1v-7" />
                        <path d="M12 20v.01" />
                        <path d="M16 20v.01" />
                        <path d="M8 20v.01" />
                        <path d="M4 20v.01" />
                        <path d="M4 16v.01" />
                        <path d="M4 12v.01" />
                        <path d="M4 8v.01" />
                        <path d="M8 4v.01" />
                        <path d="M12 4v.01" />
                        <path d="M16 4v.01" />
                        <path d="M20 4v.01" />
                        <path d="M20 8v.01" />
                        <path d="M20 12v.01" />
                        <path d="M20 16v.01" />
                        <path d="M3 3l18 18" />
                    </svg>
                    Rimuovi selezione
                </button>
            </div>

        </div>


        <div class=" mt-2" *ngIf="dataSource.length > 0">

            <div class="overflow-auto"
                [ngClass]="{'with-button': !parsedOptions.closeOnClick, 'no-button': parsedOptions.closeOnClick}"
                (scroll)="onScroll($event)">
                <div *ngFor="let data2 of dataSource; let ind = index" class="my-2">
                    <div class="flex items-center p-1 rounded-3xl  border-primary-200 border-2 transition-all transform duration-150 {{field?.cssClass}}"
                        (click)="selectItem(data2)"
                        [ngClass]="{'select-state-active': data2.selected == true, 'select-state-unactive': data2.selected != true, 'cursor-not-allowed select-state-no-active': data2.active == false, 'cursor-pointer': data2.active != true}">
                        <div class="flex">
                            <div *ngIf="parsedOptions.showImages == true">

                                <div *ngIf="!data2.hex"
                                    class="rounded-2xl w-24 h-24 flex justify-center items-center bg-white border-2 border-primary-400"
                                    style="background-image: url({{data2.svg}});background-size: cover;background-position: center	;">
                                </div>



                                <div *ngIf="data2.hex" class="rounded-2xl w-24 h-24 "
                                    [style]="'background-color: '+data2.hex">
                                </div>
                            </div>

                            <!-- <div *ngIf="data2.svg" class="rounded-2xl">
                                    <img [src]="'data:image/svg+xml;base64,'+data2.svg" class="w-20 h-12 rounded-2xl">
                                </div> -->

                            <div class="rounded-l-2xl p-2">
                                <p class="font-bold text-lg">{{data2.codice}}</p>
                                <p class="text-sm">{{data2.descrizione}}</p>
                                <p *ngIf="data2.active == false" class="text-sm">{{parsedOptions.deactivatedMessagge}}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="flex flex-col justify-center items-center" *ngIf="!endOfPagination">

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-16 h-16  animate-spin">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                    </svg>
                    <p class="text-primary-500 font-bold text-lg">Caricamento in corso</p>

                </div>

            </div>






        </div>

        <button (click)="kitDialog.close()" type="button" *ngIf="!parsedOptions.closeOnClick"
            class="dl-button  rounded-2xl lg:rounded-lg border-red-300 border-2 h-16 w-full mt-5">
            Conferma
        </button>

        <div *ngIf="dataSource.length == 0" class="mt-5">
            <p>Nessun elemento trovato</p>
        </div>
    </div>
</app-custom-dialog>